var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M7.5 26.3c-1.1-3.4-1.1-7.2.5-10.7C11.3 8.3 19.9 5 27.2 8.3M34.8 16.4c1.3 3.5 1.3 7.5-.3 11.1-3.3 7.3-11.9 10.6-19.2 7.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M27 3.4l2.2 5.8-5.8 2.2M14.2 39.1L12 33.3l5.8-2.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshSimple);
export default __webpack_public_path__ + "static/media/refreshSimple.dfea98dee67f9cc6e91bf8975f34fa93.svg";
export { ForwardRef as ReactComponent };